import React, { useState } from "react";

import { Box } from "@chakra-ui/react";
import { activateOrDeactivateODPRollOverConfig } from "api/business-user-management";
import { ReactComponent as InfoOutlineIcon } from "assets/icons/info-outline.svg";
import { useParams } from "react-router-dom";

import { Button } from "ui/button";
import { customErrorToast, customSuccessToast } from "ui/custom-toast";
import { Modal } from "ui/modal";
import { ModalHeader } from "ui/modal/modal-header";
import { defaultModalCss } from "ui/modal/styles";
import { Heading3, Paragraph3 } from "ui/typography";

import { transactionLimitModalHeaderCss } from "../../styles";
import { IActivateDeactivateRollOverModalProps } from "./types";

export const DeactivateRollOverModal = (
  props: IActivateDeactivateRollOverModalProps
) => {
  const { isOpen, setIsOpen, handleToggleModal, setOdpConfig } = props;
  const { businessId } = useParams();
  const [isDeactivating, setIsDeactivating] = useState(false);

  const handleDeactivateRollOver = async () => {
    if (!businessId) {
      console.error("Error: business id is absent! ");
      return;
    }
    setIsDeactivating(true);
    try {
      const { error, message, data } =
        await activateOrDeactivateODPRollOverConfig({
          businessId,
          isActivate: false,
        });
      if (error) {
        customErrorToast({
          message,
        });
      } else if (data) {
        setOdpConfig(data);
        customSuccessToast({
          message: "Roll Over Deactivated Successfully",
        });
        handleToggleModal();
      }
    } catch (error) {
      console.error("Error: ", error);
    }
    setIsDeactivating(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      modalCss={{
        ...defaultModalCss,
        width: "400px",
        height: "304px",
        padding: "24px",
        gap: "32px",
      }}
      allowOutsideClick={false}
    >
      <Box className="flex flex-col gap-5">
        <ModalHeader
          modalType="rejection"
          modalHeaderCss={transactionLimitModalHeaderCss}
        />
        <Box className="flex flex-col gap-2 h-[128px]">
          <Heading3
            fontSize="18px"
            lineHeight="28px"
            textColor="#101828"
            fontWeight="600"
          >
            Deactivate Roll Over
          </Heading3>
          <Paragraph3
            lineHeight="20px"
            textColor="#475467"
          >
            Please confirm that you want to perform this action.
          </Paragraph3>
          <Box className="bg-[#FEF5E7] border border-[#FFEFD8] rounded-2xl p-3 flex justify-between items-center gap-[14px]">
            <InfoOutlineIcon className="flex-shrink-0" />
            <Paragraph3
              lineHeight="20px"
              textColor=" #1A202C"
            >
              This business will no longer retain access to On-Demand Pay if
              they have not paid.
            </Paragraph3>
          </Box>
        </Box>
      </Box>
      <Box
        css={{
          height: "44px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <Button
          variant="outline"
          textColor="#344054"
          border="1px solid #D0D5DD"
          className="w-[170px]"
          onClick={handleToggleModal}
          disabled={isDeactivating}
        >
          Cancel
        </Button>
        <Button
          variant="solid"
          textColor="#ffffff"
          bgColor="#DC2626"
          border="1px solid #DC2626"
          className="w-[170px]"
          onClick={handleDeactivateRollOver}
          disabled={isDeactivating}
          loading={isDeactivating}
          loadingText="Deactivating..."
        >
          Deactivate
        </Button>
      </Box>
    </Modal>
  );
};
